export default __webpack_public_path__ + "static/media/raj kapadia.01a9b4b9.jpg";